<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },

  //   data: () => ({
  //     chartdata: {
  //       labels: [],
  //       datasets: [
  //         {
  //           label: "Horas en aire",
  //           backgroundColor: "#f87979",
  //           data: []
  //         }
  //       ]
  //     },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false
  //     }
  //   }),

  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
</script>
